<template>
  <!-- Modal -->
  <div class="modal fade" id="NewDiscardsModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('common.addition')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="alert alert-primary d-flex">
            <input v-model="keyword" class="form-control form-control-sm width-40 mr-2" type="text" :placeholder="translations('common.keyword_search')" @keyup.enter="searchProducts">
            <button type="button" class="btn btn-sm btn-primary" @click="searchProducts()">{{translations('common.search')}}</button>
            <input
              v-model="isOutlet"
              type="checkbox" id="outlet"
              name="outlet"
              class="pointer-clickable input-select-type ml-2"
              @change="changeTypeSearch('outlet')">
            <label class="center-input-here mt-2 ml-2" for="outlet">{{translations('common.outlet')}}</label>
            <input
              v-model="isNotGood"
              type="checkbox" id="notgood"
              name="notgood"
              class="pointer-clickable input-select-type ml-2"
              @change="changeTypeSearch('notgood')">
            <label class="center-input-here mt-2 ml-2" for="notgood">{{translations('common.not_good')}}</label>
          </div>
          <div class="table-scroll">
            <table class="table table-striped table-align-middle">
              <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
              <thead>
              <tr>
                <th>{{translations('discard.item_number')}}</th>
                <th>{{translations('discard.jan_code')}}</th>
                <th>{{translations('discard.model')}}</th>
                <th>{{translations('discard.quantity_stock')}}</th>
                <th>{{translations('discard.quantity')}}</th>
                <th>No.</th>
                <th>{{translations('discard.summary')}}</th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(product, key) in tempDetails">
                <tr :key="key">
                  <td>{{product.item_no}}</td>
                  <td>{{product.jan_code}}</td>
                  <td>{{product.model}}</td>
                  <td>{{ product.stock_quantity }}</td>
                  <td>
                    <input v-on:keyup="quantityKeyUp($event,product)"
                           class="form-control min-width-120" type="text"
                           v-model="product.quantity"
                           :class="{'border-danger': productsError.includes(product.product_id)}">
                  </td>
                  <td><input class="form-control min-width-120" type="text" v-model="product.client_order_number"></td>
                  <td><input class="form-control min-width-120" type="text" v-model="product.remarks"></td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="updateDetails()">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'
import { CONDITIONS_INVENTORY } from '@/constants'

export default {
  name: 'NewDiscardsModal',
  components: {
    VueElementLoading
  },
  props: {
    partnerId: {},
    warehouseId: {},
    discardDetails: {},
    applyDate: {},
    divisionType: {}
  },
  data: function () {
    return {
      tempDetails: [],
      isSearching: false,
      keyword: '',
      isNotGood: false,
      isOutlet: false,
      productsError: []
    }
  },
  mounted () {
    const self = this
    window.$('#NewDiscardsModal').on('shown.bs.modal', function () {
      self.onShown()
      window.$('#NewDiscardsModal').find('.table-scroll').css('height', (window.innerHeight - 280) + 'px')
    })
  },
  computed: {
    ...mapState(['currentLanguage']),
    conditionType () {
      if (this.isOutlet === this.isNotGood) { return CONDITIONS_INVENTORY.good.value }
      return this.isOutlet ? CONDITIONS_INVENTORY.outlet.value : CONDITIONS_INVENTORY.bad.value
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    quantityKeyUp (event, product) {
      let { value } = event.target
      value = value.replace(/\D/g, '')
      if (value && value <= 0) value = 1
      product.quantity = value
      event.target.value = product.quantity
    },
    onShown (evt) {
      this.tempDetails = []
      this.keyword = ''
    },

    async searchProducts () {
      this.isSearching = true
      try {
        let params = {
          keyword: this.keyword,
          partner_id: this.partnerId.id,
          warehouse_id: this.warehouseId.id,
          condition: this.conditionType,
          apply_date: this.applyDate,
          division_type: this.divisionType
        }
        console.log('NewDiscards:NewDiscardsModal:params', params)

        let cList = await this.$http.post(this.$api_url.discard_product_list, params)

        let $data = this.$invoiceTools.prepareResult(cList.data, 'list', 'NewDiscardsModal:searchProducts')

        console.log('NewDiscardsModal:searchProducts:response', $data)
        if ($data.success === true) {
          this.tempDetails = $data.data
          this.tempDetails.forEach(item => {
            item.unit_price = null
            item.unit_price_inctax = null
            item.client_order_number = null
            item.remarks = null
          })
        } else {
          this.tempDetails = []
          this.$toastr.error($data.data, this.translations('common.error'))
        }
        this.isSearching = false
      } catch (error) {
        console.log('NewDiscardsModal:searchProducts:catch(error): ', error)
        this.$toastr.error(this.translations('discard.notice_failed'), this.translations('common.error'))
      }
    },

    updateDetails: function () {
      let quantityError = false
      this.productsError = []
      let validItems = []
      this.tempDetails.forEach(item => {
        if ((Number(item.quantity) > Number(item.stock_quantity)) && this.divisionType === 'F') {
          quantityError = true
          this.productsError.push(item.product_id)
        } else if (Number(item.quantity) > 0) {
          item.taxclass_id = 1
          item.unit_price = 0
          item.unit_price_inctax = 0
          item.is_outlet = this.isOutlet
          item.is_bad = this.isNotGood

          validItems.push(item)
        }
      })

      if (quantityError && this.divisionType === 'F') {
        this.isSearching = false
        this.$toastr.warning(this.translations('discard.notice_valid_quantity_shipping_stock'))
        return
      }

      this.discardDetails.push(...validItems)
      this.isOutlet = false
      this.isNotGood = false
      this.$refs.closeModal.click()
    },

    changeTypeSearch (type) {
      if (type === 'outlet') {
        if (this.isOutlet) {
          this.isOutlet = true
          this.isNotGood = false
          this.searchProducts()
        } else {
          this.isOutlet = false
          this.isNotGood = false
        }
      } else if (type === 'notgood') {
        if (this.isNotGood) {
          this.isNotGood = true
          this.isOutlet = false
          this.searchProducts()
        } else {
          this.isNotGood = false
          this.isOutlet = false
        }
      }
    }
  }
}
</script>
